var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"text-info"},[_vm._v("Распечатайте заявления на вступление, подпишите его, отсканируйте/сфотографируйте и загрузите полученное изображение.")])}
var staticRenderFns = []

export { render, staticRenderFns }